import { useRequest } from 'ahooks';
import { Col, Form, Input, Radio, Row, Select } from 'antd';
import moment from 'moment';
import LocaleContext from 'locales';
import React, { useContext, useEffect } from 'react';
import { getAssignedDriveDetail, getAssignedDrives } from 'services/websocket/approval';
import { v4 as uuidv4 } from 'uuid';
import { DriveDescription, RequestInfo } from './components';
import FormItemApprovalLine from './components/FormItemApprovalLine';

export default function DriveDelete(props) {
  // variables
  const { detailData, form, id, isCreate, setIsWaitState, type, onFinishDetail, backConf } = props;

  // hooks
  const { locale } = useContext(LocaleContext);
  const fetchDrives = useRequest(getAssignedDrives, { defaultParams: [{ type }] });
  const fetchDriveDetail = useRequest(getAssignedDriveDetail, { manual: true });

  useEffect(() => {
    if (!id) {
      const applicant = localStorage.getItem('userId');
      form.setFieldsValue({
        applicant,
      });

      return;
    }

    if (detailData) {
      const contents = detailData?.contents;
      fetchDriveDetail.runAsync({ driveId: contents[0].driveId, driveType: contents[0].driveType });

      let approveDate = detailData?.approveDate;
      if (approveDate !== null && approveDate !== undefined) {
        approveDate = moment(approveDate);
      }

      // 사용자 결재인 경우
      if (detailData.approvalLines) {
        const newApprovalLines = detailData.approvalLines.map((el) => ({
          ...el,
          key: uuidv4(),
        }));
        detailData.approvalLines = newApprovalLines;
      }

      form.setFieldsValue({
        ...detailData,
        approveDate,
        contents: { ...contents[0], driveId: contents[0].driveName },
        applyDate: moment(detailData.applyDate).format('YYYY-MM-DD HH:mm:ss'),
      });

      if (setIsWaitState) {
        setIsWaitState(detailData.state === 'approval.state.waiting');
      }
    }
  }, [id, detailData]);

  // 저장 시
  const onFinish = async (values) => {
    const contentsData = fetchDriveDetail.data;
    const payload = {
      ...values,
      type,
      user: values.applicant,
      contents: [
        {
          driveId: contentsData.driveId,
          driveName: contentsData.driveName,
          driveType: contentsData.driveType,
          driveSize: contentsData.driveSize,
          owners: contentsData.owners,
          admins: contentsData.admins,
          permissions: contentsData.permissions,
          backupComplete: values.contents.backupComplete,
        },
      ],
    };
    onFinishDetail(payload);
  };

  return (
    <Form
      layout="horizontal"
      labelCol={{ span: 4 }}
      wrapperCol={{ span: 20 }}
      form={form}
      onFinish={onFinish}
    >
      <Row gutter={[0, 24]}>
        <Col span={24}>
          <RequestInfo readOnly={!isCreate} form={form} detailData={detailData} />
          <Form.Item label={locale.resource['txt.approval-type']}>
            <Input readOnly bordered={false} value={locale.resource[detailData?.type || type]} />
          </Form.Item>
          <Form.Item name="user" initialValue={localStorage.getItem('userId')} hidden>
            <Input />
          </Form.Item>
          <Form.Item
            label={locale.resource['approval.drive.select']}
            rules={[{ required: true, message: locale.resource['txt.required-field'] }]}
            name={['contents', 'driveId']}
          >
            <Select
              loading={fetchDrives.loading}
              allowClear
              options={
                fetchDrives.data?.map((el) => ({
                  label: el.driveName,
                  value: el.driveId,
                  rowData: el,
                })) || []
              }
              disabled={!isCreate}
              defaultValue={
                detailData &&
                (fetchDrives.data?.some((driver) => driver.driveId !== detailData.contents[0].id)
                  ? detailData.contents[0].driveName
                  : detailData.contents[0].id)
              }
              onSelect={(value, option) => fetchDriveDetail.runAsync(option.rowData)}
              onChange={(value) => {
                // 선택을 취소한 경우
                if (!value) {
                  fetchDriveDetail.mutate(undefined);
                }
              }}
            />
          </Form.Item>
          <Row style={{ marginBottom: 20 }}>
            <Col span={20} offset={4}>
              <DriveDescription
                data={!isCreate ? detailData?.contents[0] : fetchDriveDetail.data}
                type={type}
              />
            </Col>
          </Row>
          <Form.Item
            label={locale.resource['ask.data.backup']}
            tooltip={locale.resource['ask.data.backup.message']}
            name={['contents', 'backupComplete']}
            rules={[{ required: true, message: locale.resource['txt.required-field'] }]}
          >
            <Radio.Group disabled={!isCreate}>
              <Radio value={0}>{locale.resource['data.backup.complete']}</Radio>
              <Radio value={1}>{locale.resource['data.backup.Incomplete']}</Radio>
            </Radio.Group>
          </Form.Item>
          <FormItemApprovalLine isCreate={isCreate} form={form} backConf={backConf} type={type} />
        </Col>
      </Row>
    </Form>
  );
}
